<app-dialog class="version-check-dialog" [hideClose]="hideClose">
  <ng-container dialog-title>
    <p class="title">
      {{'module.shared.versionCheck.versionTitleText' | translate }}
    </p>
  </ng-container>
  <ng-container dialog-content>
    <div class="content">
      <div class="version-description">
        {{ 'module.shared.versionCheck.versionDescription' | translate }}
      </div>
    </div>
  </ng-container>
  <ng-container dialog-actions align="left">
    <div class="actions">
      <button class="ep-btn ep-btn-primary" (click)="reload()">{{ 'module.shared.versionCheck.versionUpdate' | translate }}</button>
    </div>
  </ng-container>
</app-dialog>
